import { Directive, ElementRef, Inject, Input, Renderer2 } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DOCUMENT } from '@angular/common';
import { PopoverController } from '@ionic/angular';
import { ShowObservationComponent } from '../components/popover/show-observation/show-observation.component';
import { KeyValuePair } from '../models/KeyValuePair';

@Directive({
    selector: '[textEllipsis]'
})
export class TextEllipsisDirective {


    @Input() textEllipsis: string = null; //texto
    @Input() fullTextEllipsis: string = null; //texto completo unchanged caso o textEllipsis tenha alguma pipe etc
    @Input() textMaxChars: number = null; //numero máximo de caracteres a mostrar
    @Input() popoverHeader: string = null; //header do popover
    @Input() btnMarginTop: string = null; //margin do botão
    @Input() fixedButton: boolean = false; //fixa posição do botão no container

    private hasClickEvent: boolean = false; //se tiver ação de abrir detalhes


    private El: ElementRef;
    constructor(el: ElementRef,
        public renderer: Renderer2,
        public translateService: TranslateService,
        public popoverController: PopoverController,
        @Inject(DOCUMENT) private document: Document) {
        this.El = el;


        // this.icon = this.document.createElement('ion-icon').setAttribute('name', 'search-outline');

        // console.log(this.icon);
    }

    ngOnInit() {
        this.setStyles();

        //se não tiver texto
        if (!this.textEllipsis || this.textEllipsis.toString().length <= 0) {
            return this.El.nativeElement.innerText = '--';
        }

        //se tiver limite de caracteres 
        if (this.textMaxChars) {
            //verifica se texto ultrapassa o limite
            //se ultrapassar mostra botão para abrir popover
            if (this.textEllipsis.toString().length > this.textMaxChars) {
                this.El.nativeElement.innerText = this.textEllipsis.toString().slice(0, this.textMaxChars) + '\u2026 '
                return this.createEllipsis();
            } else { //se não ultrapassar mostra texto
                return this.El.nativeElement.innerText = this.textEllipsis.toString();
            }
        } else { //se não tiver limite mostra sempre o botão
            return this.createEllipsis();
        }

    }

    private createEllipsis() {
        this.renderer.appendChild(this.El.nativeElement, this.btn);
        this.hasClickEvent = true;
    }

    get btn() {
        // const btn = document.createElement('ion-button');
        const btn = document.createElement('div');
        this.renderer.setAttribute(btn, 'title', this.translateService.instant('VIEW_DETAILS'));
        // this.renderer.setAttribute(btn, 'fill', 'clear');
        // this.renderer.setAttribute(btn, 'shape', 'round');
        // this.renderer.setAttribute(btn, 'color', 'tertiary');
        this.renderer.addClass(btn, 'always-show');
        this.renderer.setStyle(btn, 'margin-left', '0');
        this.renderer.setStyle(btn, 'display', 'inline-block');
        this.renderer.setStyle(btn, 'cursor', 'pointer');
        if (this.fixedButton) {
            this.renderer.setStyle(btn, 'position', 'absolute');
            this.renderer.setStyle(btn, 'right', '0');
            this.renderer.setStyle(btn, 'top', '0');
        }
        if (this.btnMarginTop) this.renderer.setStyle(btn, 'margin-top', this.btnMarginTop);

        const icon = document.createElement('ion-icon');
        this.renderer.setAttribute(icon, 'name', 'search-outline');
        this.renderer.setStyle(icon, 'color', 'var(--ion-color-tertiary)');
        this.renderer.appendChild(btn, icon);


        this.renderer.listen(btn, 'click', (event) => {
            this.openDetails(event);
        })

        return btn;
    }

    // @HostListener('click', ['$event']) async OnClick(event: Event) {
    //     // console.log('hasClickEvent: ', this.hasClickEvent);

    // }

    private async openDetails(event) {
        if (!this.hasClickEvent) return;

        const text = this.fullTextEllipsis ? this.fullTextEllipsis : this.textEllipsis || '';

        const popover = await this.popoverController.create({
            component: ShowObservationComponent,
            componentProps: {
                Data: [new KeyValuePair({ Name: this.popoverHeader || '', Value: text })],
            },
            event: event,
            translucent: true,
            showBackdrop: true,
            mode: 'ios',
            cssClass: 'custom-popover show-observation',
        });

        popover.present();
    }

    private setStyles() {
        if (this.fixedButton) {
            this.renderer.setStyle(this.El.nativeElement, 'text-overflow', 'initial');
            this.renderer.setStyle(this.El.nativeElement, 'position', 'relative');
            this.renderer.setStyle(this.El.nativeElement, 'overflow', 'visible');
        }
    }

}